import React from "react";
import Context from "../../../Context";
import BsModal from "../BsModal";
import CommentsForm from "./CommentsForm";
import CommentsList from "./CommentsList";
export default class CommentsButton extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      pending: false,
      reply: {},
      comments: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.objectId !== this.props.objectId) {
      this.load();
    }
  }
  load = async () => {
    if (this.props.objectId) {
      this.setState({ pending: true });
      let comments = await this.context.api.qa("/comment/list", {
        filter: { object: this.props.objectId },
        orderby: ["sortlist ASC"],
      });
      this.setState({ comments, pending: false });
    }
  };

  onAfterSave = (result = {}) => {
    this.setState({ reply: {} });
    this.load().then(() => {
      if (result.id) {
        let el = document.getElementById("comment" + result.id);
        if (el) {
          el.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      }
    });
  };

  onReply = (comment) => {
    this.setState({
      reply: comment,
    });
    document.querySelector(".modal-open .modal").scrollTo(0, 0);
  };

  modalShow = () => {
    this.setState({ modalShow: true });
  };
  modalClose = () => {
    this.setState({ modalShow: false });
  };

  render() {
    const { pending, comments } = this.state;
    let btnClasses = this.props.className || "btn btn-white btn-icon";
    let extraClasses = "";

    if (pending) extraClasses = "opacity-50";
    return (
      <>
        <BsModal show={this.state.modalShow} onClose={this.modalClose}>
          <CommentsForm
            parentPending={pending}
            objectId={this.props.objectId}
            reply={this.state.reply}
            onReply={this.onReply}
            onAfterSave={this.onAfterSave}
          />
          <CommentsList
            parentPending={pending}
            comments={comments}
            onReply={this.onReply}
          />
        </BsModal>
        <div
          onClick={this.modalShow}
          className={`${btnClasses} ${extraClasses}`}
          title="Комментарии"
        >
          {this.props.children}
          {!pending && comments.length > 0 && (
            <span className="label label-secondary">{comments.length}</span>
          )}
        </div>
      </>
    );
  }
}
